import { Box, Typography } from '@mui/material';

interface ResolutionHeaderProps {
  scenarioName: string;
  /** Leads the title ("Group: Scenario") when the submission belongs to a group. */
  groupName?: string;
  /** "Who, when" for each version, as the scenario history card words it. */
  baseSaved: string;
  mySaved: string;
  currentSaved: string;
}

const ResolutionHeader = ({
  scenarioName,
  groupName,
  baseSaved,
  mySaved,
  currentSaved,
}: ResolutionHeaderProps) => {
  const title = groupName
    ? `Resolve Conflicting Changes — ${groupName}: ${scenarioName}`
    : `Resolve Conflicting Changes — ${scenarioName}`;

  return (
    <Box component="header" sx={{ mb: 1 }}>
      <Typography variant="h5" component="h1">
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {`Your base version: ${baseSaved} | Your changes: ${mySaved} (pending) | Current committed version: ${currentSaved}`}
      </Typography>
    </Box>
  );
};

export default ResolutionHeader;
